module.exports = fox._r("images/promo/icon-tw.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/icon-tw.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/icon-tw.png
// module id = 165
// module chunks = 2